export default __webpack_public_path__ + "5dee754536a28043bc81e236d709de21.png";